/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBox, faCloudUploadAlt, faEdit, faFileCsv, faHome, faPeopleArrows, faPlug, faRocket, faTasks, faUpload, faUserShield } from "@fortawesome/free-solid-svg-icons"
import { Badge, Breadcrumb, Button, ButtonGroup, Card, Col, Dropdown, InputGroup, ProgressBar, Row, Table } from '@themesberg/react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import { Form } from '@themesberg/react-bootstrap';
import ReactFileReader from 'react-file-reader';
import _ from "lodash"
import Progress from "../../components/Progress"
import { PostRequest } from "../../core/API"
import { ApiSrc } from "../../resources/ApiSrc"
const moment = require('moment');
import Swal from 'sweetalert2/dist/sweetalert2.js'
// import 'sweetalert2/src/sweetalert2.scss'

export default (props) => {

  const dispatch = useDispatch();


  //const waybillRes = useSelector((state) => state.waybill);
  //const waybills = _.get(waybillRes, "waybillList.data");

  // useEffect(() => {
  //     dispatch(WaybillAction.getWaybillList({          
  //       "input": {
  //         "accountNo": "string",
  //         "barcode": "string",
  //         "expressId": "string",
  //         "reference": "string"
  //       },
  //       "token": "string"
  //     }, {
  //       sort: "createdAt,DESC"
  //     }));
  // }, [dispatch])

  const [rows, setRows] = useState();
  const [loading, setLoading] = useState();
  const [progressValue, setProgressValue] = useState();
  const [countryCode, setCountryCode] = useState(86)

  const handleFiles = files => {

    var reader = new FileReader();
    reader.onload = function (e) {
      // Use reader.result
      //alert(reader.result)
      const tmp = []
      const lists = reader.result.split("\r\n")
      if (lists !== undefined && lists.length > 1) {
        for (var i = 1; i < lists.length; i++) {
          var data = lists[i].split(",")
          var name = data[1].includes('(') ? data[1].split('(')[1].replace(')', '') : undefined
          tmp.push({
            reference: data[0],
            accountNo: data[1].split('(')[0].toUpperCase(),
            firstName: name ? name.split(' ')[0] : name,
            lastName: name ? name.split(' ')[1] : name,
            status: data[2],
            // phone:  data[3] != undefined ? data[3].replace(' ', '') : undefined
          })
        }
      }
      if (tmp.length > 0) {
        setRows(tmp)
      }
      //console.log('>> reader.result', reader)
    }
    reader.readAsText(files[0]);
  }

  const onImportPressed = async () => {
    // setLoading(true)
    // setProgressValue(0)
    // do{
    //   const item = rows.pop();
    //   const body = {
    //     "input": {
    //       "accountNo": item.accountNo,
    //       "countryCode": "86",
    //       //"height": 0.5,
    //       //"lenght": 0.1,
    //       // "volume": 0.01,
    //       // "weight": 10,
    //       // "width": 0.2,
    //       //"address": `收货人： 金边(${item.accountNo}), 邮编:528000, 联系电话：18923719413, 收货地址：广东省佛山市南海区大沥镇河西水藤村一环旁310-312(${item.accountNo})`,
    //       "reference": item.reference,
    //       "shipmentType": "land",            
    //       "status": item.status,
    //       "firstName": item.firstName,
    //       "lastName": item.lastName,
    //       "phone": item.phone,
    //     },
    //     "token": "string"
    //   }
    //   dispatch(WaybillAction.createWaybill(body));

    //   setTimeout(function(){ }, 3000);
    //   // setProgressValue(100/rows.length)

    // }while(rows.length > 0)



    for (var i = 0; i < rows.length; i++) {
      const item = rows[i]
      const body = {
        "input": {
          "accountNo": item.accountNo,
          "countryCode": countryCode,
          //"height": 0.5,
          //"lenght": 0.1,
          // "volume": 0.01,
          // "weight": 10,
          // "width": 0.2,
          //"address": `收货人： 金边(${item.accountNo}), 邮编:528000, 联系电话：18923719413, 收货地址：广东省佛山市南海区大沥镇河西水藤村一环旁310-312(${item.accountNo})`,
          "reference": item.reference,
          "shipmentType": "land",
          "status": item.status,
          "firstName": item.firstName,
          "lastName": item.lastName,
          // "phone": item.phone,
        },
        "token": "string"
      }
      // dispatch(WaybillAction.createWaybill(body));
      // setTimeout(function(){ }, 3000);
      await PostRequest(ApiSrc.CREATE_WAYBILL, body)
      setProgressValue(parseInt(100 / rows.length * (i + 1)))
    }
    // setLoading(false)
    setRows(undefined)
    setProgressValue(undefined)
  }


  return (
    <>
      {
        progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
      }

      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <Row>
            <Col xs={12} sm={6} xl={4}>
              <Form.Group className="mb-3">
                <Form.Label>From Country</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    setCountryCode(e.target.value == "--Select--" ? undefined : e.target.value)
                  }}>
                    <option value={86} selected>China</option>
                    <option value={66}>Thailand</option>
                    <option value={84}>Vietnam</option>
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={8} className={'float-end'}>
              <Row>
                <Col xs={12} sm={6} xl={8}>

                </Col>
                <Col xs={6} sm={6} xl={2}>
                  <Form.Group className="mb-4" style={{ paddingTop: 30 }}>
                    {
                      progressValue == undefined && (
                        <ReactFileReader handleFiles={handleFiles} fileTypes={'.csv'}>
                          <Button size={'sm'} variant="danger" disabled={progressValue != undefined}><FontAwesomeIcon icon={faFileCsv} /> Select file</Button>
                        </ReactFileReader>
                      )
                    }

                  </Form.Group>
                </Col>
                <Col xs={6} sm={6} xl={2} className={'float-end'}>
                  <Form.Group className="mb-4" style={{ paddingTop: 30 }}>
                    {
                      (progressValue == undefined && rows != undefined) && (
                        <Button size={'sm'} disabled={rows === undefined && progressValue != undefined} variant="success" onClick={onImportPressed}><FontAwesomeIcon icon={faBox} /> Import</Button>
                      )
                    }
                  </Form.Group>
                </Col>
              </Row>

            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="pb-0">
          <Table responsive className="table-centered table-nowrap rounded mb-0">
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">Single number</th>
                <th className="border-0">Account#</th>
                <th className="border-0">Name</th>
                <th className="border-0">Status</th>
                {/* <th className="border-0">Phone</th>  */}
              </tr>
            </thead>
            <tbody>
              {
                rows && rows.map((item, index) => {
                  return <tr>
                    <td>{index + 1}</td>
                    <td>{item.reference}</td>
                    <td>{item.accountNo}</td>
                    <td>{item.firstName ?? ''} {item.lastName ?? ''}</td>
                    <td>{item.status}</td>
                    {/* <td>{item.phone}</td>    */}
                  </tr>
                })
              }
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  )
}
